import HttpRequest from './httpRequest'

export default class CustomerTypeProvider extends HttpRequest {
  fetchCustomerTypes () {
    return this.fetch('/customer-types')
  }
}
